/* Treatment tabs: filters the collection product grid in place.
   Uses the theme's own FacetFiltersForm renderer (assets/facets.js) so the grid,
   product count, active filters and URL update together, and the back button works. */
(function () {
  if (customElements.get('treatment-tabs')) return;

  // When a collection is previewed through ?view=<template>, section requests
  // must carry the same view or Shopify cannot find the grid section.
  function keepViewParam() {
    if (typeof FacetFiltersForm === 'undefined' || FacetFiltersForm.__treatmentTabsPatched) return;
    FacetFiltersForm.__treatmentTabsPatched = true;
    var original = FacetFiltersForm.renderPage;
    FacetFiltersForm.renderPage = function (searchParams, event, updateURLHash) {
      var view = new URLSearchParams(window.location.search).get('view');
      if (view) {
        var params = new URLSearchParams(searchParams || '');
        if (!params.has('view')) {
          params.set('view', view);
          searchParams = params.toString();
        }
      }
      return original.call(this, searchParams, event, updateURLHash);
    };
  }

  class TreatmentTabs extends HTMLElement {
    connectedCallback() {
      this.key = this.dataset.filterKey;
      this.tabs = Array.prototype.slice.call(this.querySelectorAll('.treatment-tabs__tab[data-value]'));
      this.onTabClick = this.onTabClick.bind(this);
      this.sync = this.sync.bind(this);

      this.tabs.forEach(function (tab) { tab.addEventListener('click', this.onTabClick); }, this);
      // Fired by the theme after every filter change, including browser back/forward.
      document.addEventListener('collection:reloaded', this.sync);
      keepViewParam();
      this.sync(true);
      // Bring a pre-selected tab into view once the row has been laid out.
      window.requestAnimationFrame(function () { this.sync(true); }.bind(this));
    }

    disconnectedCallback() {
      document.removeEventListener('collection:reloaded', this.sync);
    }

    onTabClick(event) {
      var tab = event.currentTarget;
      if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      // No grid to update (or theme script missing): follow the link normally.
      if (typeof FacetFiltersForm === 'undefined' || !document.getElementById('product-grid')) return;

      event.preventDefault();
      var params = new URLSearchParams(window.location.search);
      params.delete(this.key);
      params.delete('page');
      if (tab.dataset.value) params.append(this.key, tab.dataset.value);

      // Show the selection straight away; the grid follows once it has loaded.
      this.setActive(tab.dataset.value);
      FacetFiltersForm.renderPage(params.toString());
    }

    sync(initial) {
      var values = new URLSearchParams(window.location.search).getAll(this.key);
      // One value = that tab; none = "All"; several (set in the filter panel) = no tab.
      var active = values.length === 1 ? values[0] : values.length === 0 ? '' : null;
      this.setActive(active, initial === true);
    }

    setActive(value, instant) {
      var activeTab = null;
      this.tabs.forEach(function (tab) {
        var on = value !== null && tab.dataset.value === value;
        tab.classList.toggle('is-active', on);
        tab.setAttribute('aria-pressed', on ? 'true' : 'false');
        if (on) activeTab = tab;
      });
      if (activeTab) {
        var list = activeTab.parentElement;
        var target = activeTab.offsetLeft - (list.clientWidth - activeTab.offsetWidth) / 2;
        if (list.scrollWidth > list.clientWidth) list.scrollTo({ left: Math.max(0, target), behavior: instant ? 'auto' : 'smooth' });
      }
    }
  }

  customElements.define('treatment-tabs', TreatmentTabs);
})();
